<template>
  <Modal
  :value="() => {}"
  :onClose="() => {}"
  :close="false"
  title="Pagamento com cartão"
  >
    <b-row class="form-group center">
      <b-col sm="12">
        <p>Selecione a forma de finalização de venda do cartão:</p>
      </b-col>
    </b-row>
    <b-row class="form-group center">
      <b-col>
        <Button type="success" @click="handleSubmitTEF()">Venda POS</Button>
      </b-col>
    </b-row>
    <b-row class="form-group center">
      <b-col>
        <Button type="success" @click="handleSubmitTEFStone()">POS integrado Stone</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';

export default {
  name: 'ModalTEF',
  components: {
    Modal,
    Button,
  },
  props: {
    submitTEF: {
      type: Function,
      required: true,
    },
    submitTEFStone: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async handleSubmitTEF() {
      return this.submitTEF();
    },
    async handleSubmitTEFStone() {
      return this.submitTEFStone();
    },
  },
};
</script>

<style>
  .center {
    text-align: center!important;
  }
</style>
